<template>
  <section class="screen">


    <div v-for="(display, idx) in cards" class="tab" :key="idx">
        <div class="tab__type" :class="[$options.filters.cardColor(display.type)]"></div>
        <div class="tab__name">{{ display.type | cardType}}</div>
        <div v-if="display.description" class="tab__description">{{display.description}}</div>
    </div>

<!-- <div class="tab">
          <div class="tab__type orange"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
    <div class="tab" @click="$router.push('/scheduled')">
          <div class="tab__type yellow"></div>
          <div class="tab__name">SCHEDULED - Cleaning</div>
          <div class="tab__description">January 12th, 2016 (10am)</div>
      </div>
    <div class="tab">
          <div class="tab__type media">
              <img src="/static/media.svg">
          </div>
          <div class="tab__name">New visual media added</div>
          <div class="tab__description">8-23-19</div>
      </div>
    <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Prescripiton updated</div>
          <div class="tab__description">PAST - March 18th - 2018</div>
      </div>
      <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
      <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
      <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
    <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div> -->



  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'
import { firestore } from "../main";
import * as firebase from "firebase";
import { mapMutations, mapGetters } from 'vuex'


export default {
  name: 'heroSection',
  data () {
    return {
        cards: [{}]
    }
  },
firestore() {
    return {
      cards: firestore.collection('cards').where("uid", "==", this.user.uid)
  }
},
  watch: {

  },
  method: {
    ...mapMutations([
      'logModules',
      'logIn',
      'logOut',
      'logInGoogle'
    ])
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading'
    ])
  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

.screen {
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: rgb(242, 248, 255);
    margin-top: 50px;
    padding: 20px 0 20px 0;
    width: 100%;
    align-items: center;
    height: auto;
    .tab {
        width: 90%;
        height: auto;
        padding: 20px 0;
        background-color: #fff;
        box-shadow: 1px 1px 2px rgb(195, 202, 211);
        border-radius: 5px;
        margin: 5px 0;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        justify-content: center;
        color: #777;
        cursor: pointer;
        &:hover {
            background-color: #f5fcff;
        }
 
        &__type {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: 20px;
        }

            // sub settings of type
            .orange {
                background-color: $accentColor;
            }
            .yellow {
                background-color: #f8e85b;
            }
            .media {
                width: 30px;
                height: 30px;
                margin-left: -5px;
                img {
                    width: 20px;
                }
            }
            .grey {
                background-color: #ddd;
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
}

  
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue